import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDownFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	viewBox: "0 0 8 6",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.284487 1.863L2.81149 4.682C2.89663 4.78283 3.00275 4.86387 3.12244 4.91946C3.24213 4.97505 3.37251 5.00385 3.50449 5.00385C3.63646 5.00385 3.76684 4.97505 3.88653 4.91946C4.00623 4.86387 4.11235 4.78283 4.19749 4.682L6.72449 1.863C6.86174 1.69896 6.95266 1.50121 6.98783 1.29022C7.02299 1.07924 7.00112 0.862693 6.92449 0.663C6.86248 0.472352 6.74235 0.305899 6.58094 0.186995C6.41953 0.0680899 6.22495 0.00270036 6.02449 0H0.977486C0.777027 0.00270036 0.582443 0.0680899 0.421034 0.186995C0.259625 0.305899 0.13949 0.472352 0.0774859 0.663C0.00178965 0.863297 -0.0189333 1.0802 0.0174655 1.29121C0.0538642 1.50221 0.146059 1.69964 0.284487 1.863Z",
		fill: "#545F7E"
	})]
});
const ForwardRef = forwardRef(SvgArrowDownFilled);
export default ForwardRef;
